import { FunctionComponent, ReactElement } from "react";
import Select, { SingleValue, SingleValueProps, OptionProps, components } from "react-select";

// Types
import { CustomColumnFilterOption } from "../../../utils/types";

const { Option, SingleValue: SingleValueComponent } = components;

interface ColumnFilterSelectProps {
	isDisabled: boolean | undefined;
	options: Array<CustomColumnFilterOption>;
	existingValue: string | number;
	onChangeHandler: (newValue: SingleValue<CustomColumnFilterOption>) => void;
}

const ColumnFilterSingleSelect: FunctionComponent<ColumnFilterSelectProps> = (
	props: ColumnFilterSelectProps
): ReactElement => {
	const { isDisabled, options, existingValue, onChangeHandler } = props;

	const getSelectOption = (optionProps: OptionProps<CustomColumnFilterOption>) => {
		return (
			<Option {...optionProps} key={`lampselect-${optionProps.data.value}`}>
				{optionProps.data.icon && optionProps.data.icon}
				{optionProps.data.label}
			</Option>
		);
	};

	const getSingleValueOption = (valueProps: SingleValueProps<CustomColumnFilterOption>) => {
		return (
			<SingleValueComponent {...valueProps}>
				{valueProps.data.icon ? valueProps.data.icon : valueProps.data.label}
			</SingleValueComponent>
		);
	};

	const onChangeInternalHandler = (newValues: SingleValue<CustomColumnFilterOption>): void => {
		onChangeHandler(newValues);
	};

	const getSelectedValue = (): Array<CustomColumnFilterOption> => {
		if (existingValue) {
			return options.filter((option: CustomColumnFilterOption) =>
				existingValue.toString().includes(option.value.toString())
			);
		} else return [];
	};

	return (
		<Select
			options={options}
			value={getSelectedValue()}
			components={{ Option: getSelectOption, SingleValue: getSingleValueOption }}
			menuPortalTarget={document.body}
			isMulti={false}
			placeholder={""}
			isClearable={true}
			isDisabled={isDisabled}
			onChange={(newValues: SingleValue<CustomColumnFilterOption>) => onChangeInternalHandler(newValues)}
			styles={{
				menuPortal: (base) => ({ ...base, zIndex: 9999 }),
				option: (base) => ({ ...base, display: "flex", padding: "5px 10px" }),
				menuList: (base) => ({ ...base, width: "max-content", fontSize: "0.9rem" }),
				menu: (base) => ({ ...base, width: "auto" }),
				valueContainer: (base) => ({ ...base, minWidth: "32px", paddingRight: 0, fontWeight: 400 }),
				singleValue: (base) => ({ ...base, textOverflow: "unset" }),
				control: (base) => ({
					...base,
					minWidth: existingValue && options?.[0]?.icon == null ? "140px" : "32px",
					minHeight: "32px",
					borderColor: "gray.300"
				}),
				container: (base) => ({ ...base, width: "100%" }),
				dropdownIndicator: (base) => ({ ...base, padding: "5px 8px" }),
				clearIndicator: (base) => ({ ...base, padding: "5px 0px 5px 8px" }),
				indicatorSeparator: (base) => ({ ...base, display: "none" })
			}}
		/>
	);
};

export default ColumnFilterSingleSelect;
